import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "@/store/store";
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { toast } from "react-toastify";
import useGetRole from "@/hooks/useGetRole";
import { adminMessage, visitMessage } from "@/utils/constants";

import {
    updateNewAppointment,
    updateExistAppointment,
} from "@/store/appointments/appointmentsSlice";

export default function AppointmentsInfoSelector({
    isAppointmentComplete,
}: {
    isAppointmentComplete: boolean;
}) {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const dispatch = useDispatch();
    const { isAdmin } = useGetRole();
    const isEditAppointment = useSelector(
        (state: RootState) => state.ui.isEditAppointment,
    );

    const chairNumber = useSelector((state: RootState) =>
        isEditAppointment
            ? state.appointments.existtAppointment.chairNumber
            : state.appointments.newAppointment.chairNumber,
    );

    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        if (isAdmin) {
            if (!isAppointmentComplete) {
                setAnchorEl(event.currentTarget);
            } else toast.error(visitMessage);
        } else toast.error(adminMessage);
    };

    const handleClose = (chair?: string) => {
        if (chair) {
            const num = +chair.split(" ")[0];
            const action = isEditAppointment
                ? updateExistAppointment
                : updateNewAppointment;
            dispatch(action({ chairNumber: num }));
        }
        setAnchorEl(null);
    };

    return (
        <>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "14px",
                    borderRadius: "6px",
                    border: open
                        ? "1px solid #1367B5 !important"
                        : "1px solid #BCC3CD !important",
                    cursor: "pointer",
                }}
                onClick={handleClick}
                className='appointment_left_part_selector'
            >
                <p style={{ color: "#090b0e" }}>{chairNumber} крісло</p>
                <img
                    src='/appointmenspage/arrow-down.svg'
                    alt='logo_arrow'
                    className='app_arrow_img'
                />
            </Box>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={() => handleClose()}
                disableAutoFocusItem
                onKeyDown={event => {
                    if (event.key === "Tab") {
                        event.preventDefault();
                    }
                }}
                sx={{
                    "& .MuiPaper-root": {
                        width: "auto",
                        height: "auto",
                        overflow: "visible",
                        boxShadow: "0px 2px 8px rgba(0,0,0,0.32)",
                        mt: "10px",
                        left: "270px !important",
                        right: "557px !important",
                    },
                    "& .MuiList-root": {
                        padding: "0 !important",
                    },
                }}
                {...(open ? {} : { "aria-hidden": "true" })}
            >
                {[
                    "1 крісло",
                    "2 крісло",
                    "3 крісло",
                    "4 крісло",
                    "5 крісло",
                    "6 крісло",
                ].map(chair => (
                    <MenuItem
                        sx={{
                            padding: "10px 14px",
                            fontWeight: "400",
                            fontFamily: "Nunito Sans, sans-serif",
                            fontSize: "14px",
                            color: "#090b0e",
                            lineHeight: "20px",
                            transition: "all 0.3s linear",
                            "&:hover": {
                                backgroundColor: "#F2F4F7",
                            },
                        }}
                        tabIndex={-1}
                        key={chair}
                        onClick={() => handleClose(chair)}
                    >
                        {chair}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
}
